import { axios } from '@Root/API'

export const get = feesId => {
	return axios.delete(`fee-details/${feesId}`)
}
